/**
 * @module Root-Layout
 */

import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setHeader } from "../globals/layout-functions";
import AppRoutes from "../routing/app-routes";
import SectionFooter from "../app/sections/common/footer";
import Loader from "../globals/elements/loader";
import SEOHead from "../components/SEOHead";
import './root-layout.scss';

/**
 * 
 * @returns Wrapper Element, Entire {@link AppRoutes | template flow} loaded inside this global layout
 */
const RootLayout = () => {
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        // Show loader when route changes
        setIsLoading(true);
        
        // Scroll to top immediately to prevent jarring transitions
        window.scrollTo(0, 0);
        
        // Use a consistent loading time for smooth transitions
        const loadingTimeout = setTimeout(() => {
            setIsLoading(false);
        }, 800); // Slightly longer loading time for smoother experience
        
        return () => clearTimeout(loadingTimeout);
    }, [location.pathname]);

    return (
        <>
            {/* Dynamic SEO Head */}
            <SEOHead />
            
            <div className="page-wraper">
                {isLoading && <Loader />}
                
                {/* Page Header */}
                {
                    setHeader(location.pathname)
                }

                {/* CONTENT START */}
                <div className={`page-content ${isLoading ? 'loading' : 'loaded'}`}>
                    <AppRoutes />
                </div>
                {/* CONTENT END */}

                {/* Page Footer */}
                <SectionFooter />

                {/* BUTTON TOP START */}
                <button className="scroltop"><span className="fa fa-angle-up  relative" id="btn-vibrate" /></button>
            </div>
        </>
    )
}
export default RootLayout;